module.exports = __webpack_public_path__ + "static/media/cardskeleton.50028d60.png";